import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFanatec = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M39.865 26.091c-2.97 0-5.91 0-7.926 1.404s-3.11 4.21-4.263 7.194q-.643 1.649-1.285 3.298h56.516Q85.2 32.04 87.5 26.091zM24.069 44.013l-4.604 11.896H75.99l4.594-11.896zm-6.954 17.999L12.5 73.908h17.608l4.615-11.896z" })
});
export default SvgFanatec;
